import axios from 'axios';

import { v4 as uuidv4 } from 'uuid';
import { API_URL } from '../../env';
import {
  handleInterceptResponseError,
  handleInterceptResponseSuccess,
} from './interceptors';

const apiClientOld = axios.create({
  baseURL: API_URL,
});

apiClientOld.interceptors.request.use(config => {
  if (config.headers) {
    config.headers.cid = uuidv4();
  }
  return config;
});

apiClientOld.interceptors.response.use(
  handleInterceptResponseSuccess,
  handleInterceptResponseError,
);

export const setBearerToken = (token: string) => {
  apiClientOld.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

export { apiClientOld };
